/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class MainMenu {
  constructor (element) {
    this.$el = $(element)
    this.$subMenuHeaders = this.$el.find('.mainMenu-hasSubMenu')

    // Remove submenu focus ability until needed.
    this.$subMenuHeaders.find('.subNav-link').attr('tabindex', '-1')
    this.$subMenuHeaders.find('.mainMenu-subNav').attr('aria-expanded', 'false')

    // Listen to all menu items to reset dropdowns
    this.$el.on('focusin', '.mainMenu-item:not(.mainMenu-hasSubMenu)', (e) => {
      this.$subMenuHeaders.find('.subNav-link').attr('tabindex', '-1')
      this.$subMenuHeaders.find('.mainMenu-subNav').attr('aria-expanded', 'false')
    })

    // Listen for down arrow on focus, to allow submenu focus.
    this.$el.on('focusin', '.mainMenu-hasSubMenu', (e) => {
      $(e.currentTarget).on('keydown', (e) => {
        if (e.which === 40) {
          $(e.currentTarget).find('.subNav-link').attr('tabindex', '0')
          $(e.currentTarget).find('.subNav-item:first-child a').focus()
          $(e.currentTarget).find('.mainMenu-subNav').attr('aria-expanded', 'true')
        }
      })
    })

    // Menu fix for IE11
    if ($('body').hasClass('browser-ie11')) {
      this.$el.on('mouseenter', '.mainMenu-hasSubMenu', (e) => {
        $(e.currentTarget).addClass('mainMenu-hasSubMenu--open')
        $(e.currentTarget).find('.subNav-link').attr('tabindex', '0')
        $(e.currentTarget).find('.mainMenu-subNav').attr('aria-expanded', 'true')
      })
      this.$el.on('mouseleave', '.mainMenu-hasSubMenu', (e) => {
        $(e.currentTarget).removeClass('mainMenu-hasSubMenu--open')
        $(e.currentTarget).find('.subNav-link').attr('tabindex', '-1')
        $(e.currentTarget).find('.mainMenu-subNav').attr('aria-expanded', 'false')
      })
    }
  }
}

registerClass('MainMenu', MainMenu)
